import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const TOKEN_KEY = "sinhron_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Došlo je do greške.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export const PRIORITIES = [
  { value: "visok", label: "Visok", color: "#C65D47", bg: "#FDF0ED" },
  { value: "srednji", label: "Srednji", color: "#D99A5B", bg: "#FDF6F0" },
  { value: "nizak", label: "Nizak", color: "#82937E", bg: "#F3F5F2" },
];

export const priorityMeta = (p) => PRIORITIES.find((x) => x.value === p) || PRIORITIES[1];

/**
 * Doba dana (na osnovu lokalnog vremena):
 * - jutro:  4h–10:59
 * - dan:    11h–17:59
 * - veče:   18h–3:59
 */
export function getDayPeriod(date = new Date()) {
  const h = date.getHours();
  if (h >= 4 && h < 11) return "morning";
  if (h >= 11 && h < 18) return "day";
  return "evening";
}

export function greetSr(date = new Date()) {
  return { morning: "Dobro jutro", day: "Dobar dan", evening: "Dobro veče" }[getDayPeriod(date)];
}

export function overviewLabelSr() {
  // Neutralan naziv koji ne kontradiktuje pozdravu koji zavisi od doba dana.
  return "AI pregled";
}
